{
  "common": {
    "loading": "Loading...",
    "save": "Save",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "delete": "Delete",
    "edit": "Edit",
    "create": "Create",
    "search": "Search",
    "filter": "Filter",
    "actions": "Actions",
    "status": "Status",
    "noResults": "No results found",
    "previous": "Previous",
    "next": "Next",
    "yes": "Yes",
    "no": "No",
    "success": "Operation successful",
    "error": "An error occurred",
    "id": "ID",
    "date": "Date",
    "back": "Back",
    "retry": "Retry",
    "all": "All",
    "close": "Close",
    "loadMore": "Load More",
    "showingRange": "Showing {{start}}-{{end}} of {{total}}",
    "rowsPerPage": "Rows per page",
    "totalResults": "{{total}} result(s)",
    "loadError": "Failed to load data.",
    "viewDetail": "View details"
  },
  "header": {
    "searchPlaceholder": "Search users, orders, items..."
  },
  "auth": {
    "login": "Log in",
    "logout": "Log out",
    "email": "Email address",
    "otpCode": "Verification code",
    "sendCode": "Send code",
    "verifyCode": "Verify",
    "notAdmin": "This account does not have administrator privileges.",
    "sessionExpired": "Your session has expired. Please log in again.",
    "codeSentTo": "Code sent to",
    "unavailable": {
      "title": "Service temporarily unavailable",
      "message": "We could not verify your session right now. You have not been signed out.",
      "retry": "Retry"
    },
    "errors": {
      "failedToSendCode": "Failed to send verification code",
      "notFullyRegistered": "This account is not fully registered.",
      "invalidCode": "Invalid verification code",
      "emailRequired": "Enter an email address.",
      "otpRequired": "Enter the verification code."
    }
  },
  "nav": {
    "platformWallet": "Blisterr wallet",
    "dashboard": "Dashboard",
    "general": "General",
    "catalog": "Catalog",
    "moderation": "Moderation",
    "reports": "Reports",
    "reviews": "Reviews",
    "messaging": "Messaging",
    "peeks": "Items",
    "shops": "Shops",
    "users": "Users",
    "sellerRequests": "Seller Requests",
    "finance": "Finance",
    "buyerStrikes": "Buyer Strikes",
    "sellerDebts": "Seller Debts",
    "missingInvoices": "Missing Invoices",
    "pdpSubmissionReviews": "PDP Reviews",
    "commerce": "Commerce",
    "orders": "Orders",
    "lives": "Lives",
    "discounts": "Discounts",
    "referralCampaigns": "Referral Campaigns",
    "configuration": "Configuration",
    "categories": "Categories",
    "deliveryCarriers": "Delivery Carriers",
    "shippingRates": "Shipping Rates",
    "search": "Search",
    "system": "System",
    "reconciliation": "Reconciliation",
    "queues": "Queues",
    "adminActions": "Admin Actions",
    "systemHealth": "System Health",
    "launchStatus": "Launch Status",
    "nodes": "Nodes",
    "infrastructure": "Infrastructure",
    "emails": "Email Templates",
    "notificationDeliveries": "Notification deliveries",
    "reference": "Reference",
    "referenceTcg": "TCG",
    "referenceIngestion": "Ingestion",
    "personal": "My account",
    "settings": "Settings",
    "productRequests": "Product requests",
    "support": "Support",
    "supportTickets": "Support Tickets"
  },
  "dashboard": {
    "title": "Dashboard",
    "totalUsers": "Total Users",
    "totalSellers": "Total Sellers",
    "activeLives": "Active Lives",
    "totalOrders": "Total Orders",
    "revenue": "Net collected fees",
    "pendingModeration": "Pending Moderation",
    "pendingReports": "Pending Reports",
    "pendingSellerRequests": "Pending Seller Requests",
    "newUsersToday": "New Today",
    "newUsersThisWeek": "New This Week",
    "ordersToday": "Orders Today",
    "revenueToday": "Revenue Today",
    "itemsOnSale": "Items On Sale",
    "itemsSold": "Items Sold",
    "itemsDraft": "Draft Items",
    "attentionRequired": "Attention Required",
    "quickActions": "Quick Actions",
    "secondaryStats": "Detailed Stats",
    "reviewReports": "Review reports",
    "reviewSellerRequests": "Review requests",
    "runReconciliation": "Run reconciliation",
    "createDiscount": "Create discount",
    "attentionReports": "{{count}} pending report(s)",
    "attentionSellerRequests": "{{count}} pending seller request(s)",
    "attentionStrikes": "{{count}} active buyer strike(s)",
    "attentionSellerDebts": "{{count}} outstanding seller debt(s)",
    "attentionReconciliation": "{{count}} failed reconciliation(s)",
    "attentionMissingInvoices": "{{count}} missing invoice(s)",
    "loadError": "Failed to load dashboard data"
  },
  "reports": {
    "title": "Reports",
    "detail": "Report Detail",
    "targetType": "Target Type",
    "reason": "Reason",
    "reporter": "Reporter",
    "review": "Review",
    "resolve": "Resolve",
    "dismiss": "Dismiss",
    "resolveDialogTitle": "Resolve Report",
    "resolveDialogMessage": "Are you sure you want to mark this report as resolved? This action confirms the report has been addressed.",
    "resolveReasonPlaceholder": "Explain how this report was resolved (required)",
    "dismissDialogTitle": "Dismiss Report",
    "dismissDialogMessage": "Are you sure you want to dismiss this report? This indicates the report does not require further action.",
    "filterByStatus": "Filter by status",
    "tabs": {
      "byContent": "By flagged content",
      "byReport": "By report"
    },
    "status": {
      "PENDING": "Pending",
      "REVIEWING": "Reviewing",
      "RESOLVED": "Resolved",
      "DISMISSED": "Dismissed"
    },
    "toast": {
      "reviewing": "Report marked as reviewing",
      "resolved": "Report resolved",
      "dismissed": "Report dismissed"
    }
  },
  "reviews": {
    "title": "Reviews",
    "hide": "Hide",
    "reject": "Reject",
    "republish": "Republish",
    "rating": "Rating",
    "reviewer": "Reviewer",
    "confirmHide": "Are you sure you want to hide this review?",
    "confirmReject": "Are you sure you want to reject this review? This will notify the reviewer.",
    "confirmRepublish": "Are you sure you want to republish this review?",
    "hiddenSuccess": "Review hidden",
    "rejectedSuccess": "Review rejected",
    "republishedSuccess": "Review republished",
    "status": {
      "PUBLISHED": "Published",
      "HIDDEN": "Hidden",
      "REJECTED": "Rejected"
    }
  },
  "items": {
    "title": "Items",
    "detail": "Item Detail",
    "searchPlaceholder": "Search by name or seller...",
    "itemsFound": "{{count}} item(s) found",
    "allStatuses": "All Statuses",
    "allTypes": "All Types",
    "allModeration": "All Moderation",
    "allContexts": "All Contexts",
    "flag": "Flag",
    "clear": "Clear Flag",
    "seller": "Seller",
    "shop": "Shop",
    "price": "Price",
    "flagReason": "Flag Reason",
    "flagReasonPlaceholder": "Enter the reason for flagging...",
    "generalInfo": "General Information",
    "description": "Description",
    "condition": "Condition",
    "category": "Category",
    "country": "Country",
    "weight": "Weight",
    "quantity": "Quantity",
    "followers": "Followers",
    "createdAt": "Created At",
    "soldDate": "Sold Date",
    "pricing": "Pricing",
    "startDate": "Start Date",
    "endDate": "End Date",
    "audience": "Audience",
    "startingPrice": "Starting Price",
    "currentPrice": "Current Price",
    "duration": "Duration",
    "auctionType": "Auction Type",
    "bidCount": "Bids",
    "liveId": "Live",
    "participants": "Participants",
    "media": "Media",
    "noImages": "No images",
    "video": "Video",
    "moderationSection": "Moderation",
    "moderationStatus": "Moderation Status",
    "moderationReason": "Reason",
    "moderatedBy": "Moderated By",
    "moderatedAt": "Moderated At",
    "context": "Context",
    "peek": "Peek",
    "live": "Live",
    "status": {
      "DRAFT": "Draft",
      "SCHEDULED": "Scheduled",
      "ON_SALES": "On Sales",
      "RESERVED": "Reserved",
      "SOLD": "Sold",
      "UNSOLD": "Unsold",
      "ARCHIVED": "Archived",
      "DELETED": "Deleted"
    },
    "type": {
      "FIXED_PRICE": "Fixed Price",
      "AUCTION": "Auction",
      "GIVEAWAY": "Giveaway"
    },
    "moderation": {
      "FLAGGED": "Flagged",
      "CLEARED": "Cleared",
      "NONE": "None"
    },
    "unpublish": "Take Down",
    "forceDelete": "Force Delete",
    "republish": "Republish",
    "editItem": "Edit Item",
    "unpublishConfirmTitle": "Take Down Item",
    "unpublishConfirmMessage": "This will remove the item \"{{title}}\" from the marketplace. The seller will be notified.",
    "forceDeleteConfirmTitle": "Force Delete Item",
    "forceDeleteConfirmMessage": "This will PERMANENTLY delete the item \"{{title}}\". This action is irreversible.",
    "republishConfirmTitle": "Republish Item",
    "republishConfirmMessage": "This will put the item \"{{title}}\" back on sale on the marketplace.",
    "editSuccess": "Item updated",
    "unpublishSuccess": "Item taken down",
    "forceDeleteSuccess": "Item deleted",
    "republishSuccess": "Item republished",
    "endAuction": "End Auction",
    "endAuctionConfirmTitle": "End Auction",
    "endAuctionConfirmMessage": "This will end the auction immediately. The last bidder will be declared the winner. This action is irreversible.",
    "endAuctionSuccess": "Auction ended",
    "drawGiveaway": "Draw Winner",
    "drawGiveawayConfirmTitle": "Draw Giveaway Winner",
    "drawGiveawayConfirmMessage": "This will randomly pick a winner from the giveaway participants. This action is irreversible.",
    "drawGiveawaySuccess": "Giveaway drawn",
    "launchItem": "Launch Now",
    "launchItemTitle": "Launch Sale Now",
    "launchItemMessage": "This will immediately launch the sale for this item, without waiting for the scheduled date. This action is irreversible.",
    "launchItemSuccess": "Sale launched successfully",
    "launchItemError": "Failed to launch sale",
    "scheduledJobs": "Scheduled Jobs",
    "scheduledAuctionEnd": "Scheduled auction end",
    "scheduledGiveawayDraw": "Scheduled draw",
    "scheduledSaleStart": "Scheduled sale start",
    "noScheduledJobs": "No scheduled jobs",
    "videoSection": "Video",
    "videoUrl": "Video URL",
    "videoId": "Video ID",
    "videoStatus": "Processing Status",
    "videoStatusReady": "Ready",
    "videoStatusProcessing": "Processing",
    "videoStatusNone": "No video",
    "openVideo": "Open video",
    "emptyFilterTitle": "No items match your filters",
    "emptyFilterDescription": "Try adjusting the filters or clearing them to see all items.",
    "clearFilters": "Clear filters"
  },
  "users": {
    "title": "User Management",
    "searchPlaceholder": "Search by name, email or phone...",
    "allStatuses": "All statuses",
    "allRoles": "All roles",
    "usersFound": "user(s) found",
    "accountInfo": "Account Information",
    "address": "Address",
    "street": "Street",
    "city": "City",
    "zipCode": "Zip Code",
    "country": "Country",
    "shop": "Shop",
    "shopName": "Shop Name",
    "shopId": "Shop ID",
    "wallet": "Wallet",
    "balance": "Balance",
    "actions": "Actions",
    "suspend": "Suspend",
    "ban": "Ban",
    "reactivate": "Reactivate",
    "confirmSuspend": "Are you sure you want to suspend this user?",
    "confirmBan": "Are you sure you want to ban this user? This action is irreversible.",
    "confirmReactivate": "Are you sure you want to reactivate this user?",
    "banMessaging": "Ban from Messaging",
    "confirmBanMessaging": "Are you sure you want to ban this user from sending messages? They will no longer be able to send private messages or live chat.",
    "unbanMessaging": "Unban from Messaging",
    "confirmUnbanMessaging": "Are you sure you want to restore this user's ability to send messages?",
    "unbannedMessaging": "User unbanned from messaging",
    "suspended": "User suspended",
    "banned": "User banned",
    "reactivated": "User reactivated",
    "actionFailed": "Action failed",
    "loadFailed": "Failed to load user",
    "role": "Role",
    "currentRole": "Current role",
    "confirmSetRole": "Are you sure you want to assign the {{ role }} role to {{ username }}?",
    "confirmRoleChange": "Change role",
    "roleChanged": "Role updated",
    "roleChangeFailed": "Failed to change role",
    "grantAdmin": "Grant admin role",
    "revokeAdmin": "Revoke admin role",
    "confirmGrantAdmin": "Grant admin role to {{username}}?",
    "confirmRevokeAdmin": "Revoke admin role from {{username}}?",
    "relatedLinks": "Related",
    "viewOrders": "View orders ({{count}})",
    "viewStrikes": "View strikes ({{count}})",
    "viewReports": "View reports ({{count}})",
    "viewShop": "View shop",
    "restrictionDetails": "Restriction Details",
    "banReason": "Ban Reason",
    "suspensionExpiry": "Suspension Expiry",
    "preferences": {
      "sectionTitle": "User preferences",
      "notificationsSectionTitle": "Notification preferences",
      "locale": "Language",
      "theme": "Appearance",
      "profileVisibility": "Profile visibility",
      "allowMessaging": "Messaging",
      "category": "Category",
      "loadError": "Could not load user preferences",
      "locales": {
        "fr": "French",
        "en": "English"
      },
      "themes": {
        "LIGHT": "Light",
        "DARK": "Dark",
        "SYSTEM": "System"
      },
      "visibilities": {
        "PUBLIC": "Public",
        "FOLLOWERS_ONLY": "Followers only",
        "PRIVATE": "Private"
      },
      "messagingPolicies": {
        "ALL": "Everyone",
        "FOLLOWING_ONLY": "People you follow",
        "NONE": "No one"
      },
      "categories": {
        "transactional": "Transactional",
        "social": "Social",
        "live": "Live",
        "marketing": "Marketing"
      },
      "channels": {
        "push": "Push",
        "email": "Email",
        "sms": "SMS"
      },
      "notifications": {
        "lockedHint": "Always on — required by French commerce law."
      }
    },
    "discord": {
      "title": "Discord account",
      "linked": "Discord: connected (@{{username}}) since {{date}}",
      "notLinked": "Discord: not connected",
      "presence": {
        "PRESENT": "On the server",
        "ABSENT": "Not on the server",
        "UNKNOWN": "Presence unknown"
      },
      "recent": "Recently connected (less than 72 hours)",
      "roles": "Roles",
      "roleState": {
        "granted": "Granted",
        "pending": "Pending",
        "review": "To regularize",
        "notGranted": "Not granted"
      },
      "syncStale": "Sync is late",
      "reason": {
        "ELIGIBLE": "Conditions met",
        "ACCOUNT_RESTRICTED": "Restricted account (suspended or banned)",
        "NOT_A_VERIFIED_SELLER": "Seller request not approved",
        "NO_ACTIVE_SHOP": "No active shop",
        "ACTIVE_STRIKE": "Active buyer strike",
        "NO_PAID_ORDER": "No paid order",
        "HIDDEN_BY_MEMBER": "Hidden by the member"
      },
      "sync": {
        "lastPass": "Last roles pass",
        "never": "No pass yet",
        "failures": "Consecutive failures",
        "lastError": "Last error",
        "removalDeferredUntil": "Removal deferred until"
      },
      "syncError": {
        "MEMBER_NOT_MANAGEABLE": "Discord refuses to change this member's roles (server owner, or a role above the bot's). No retry."
      },
      "unlink": "Disconnect Discord account",
      "unlinkTitle": "Forced disconnection of the Discord account",
      "unlinkBody": "The Marchand ✓ and Looteur ✓ roles will be removed from this member. Enter the reason, it is kept in the actions log. If the account is hijacked, suspend it first to disconnect its sessions.",
      "unlinkConfirm": "Disconnect Discord",
      "reasonPlaceholder": "Reason for disconnecting Discord (3 to 200 characters)…",
      "blockRelink": "Prevent this Discord account from being connected again for 24 hours",
      "unlinked": "Discord account disconnected.",
      "unlinkedBlocked": "Discord account disconnected. Reconnection blocked for 24 hours.",
      "loadError": "Unable to load the Discord status of this account.",
      "error": {
        "notLinked": "This Discord account is no longer connected.",
        "disabled": "Connecting Discord accounts is turned off on this environment. Nothing was disconnected.",
        "unavailable": "Disconnecting the Discord account is impossible: the reconnection block could not be saved. Nothing was disconnected."
      }
    }
  },
  "sellerRequests": {
    "title": "Seller Requests",
    "detail": "Seller Request Detail",
    "stats": "Statistics",
    "preApprove": "Pre-approve",
    "approve": "Approve",
    "sendBack": "Send Back",
    "reject": "Reject",
    "revoke": "Revoke Access",
    "applicantInfo": "Applicant Info",
    "companyInfo": "Company Info",
    "personalInfo": "Personal Info",
    "businessInfo": "Business Info",
    "noBusinessInfo": "No business information submitted yet.",
    "address": "Address",
    "verification": "Verification",
    "existingRemarks": "Admin Remarks",
    "adminActions": "Admin Actions",
    "currentStatus": "Current status",
    "preApproveDialogTitle": "Pre-approve Seller Request",
    "preApproveDialogMessage": "This will allow the seller to complete their profile and connect Stripe. Are you sure you want to pre-approve this request?",
    "approveDialogTitle": "Approve Seller Request",
    "approveDialogMessage": "This will grant seller access to this user. Are you sure you want to approve this request?",
    "rejectDialogTitle": "Reject Seller Request",
    "rejectDialogMessage": "Are you sure you want to reject this seller request? Please add remarks to explain the reason.",
    "sendBackDialogTitle": "Send Back for Correction",
    "sendBackDialogMessage": "Send this request back to the seller for correction. Add remarks to explain what needs to be fixed.",
    "revokeDialogTitle": "Revoke Seller Access",
    "revokeDialogMessage": "You are about to permanently revoke this seller's access. This action is irreversible. Please provide a detailed reason.",
    "revokeConsequencesTitle": "Consequences of revocation",
    "revokeConsequence1": "Seller role will be removed from the user account",
    "revokeConsequence2": "All listed items will be archived and unpublished",
    "revokeConsequence3": "Active and scheduled lives will be stopped immediately",
    "revokeConsequence4": "Stripe Connect account will be deactivated",
    "revokeRemarksPlaceholder": "Explain the reason for revoking seller access (required)...",
    "remarksPlaceholder": "Add remarks...",
    "status": {
      "SUBMITTED": "Submitted",
      "PRE_APPROVED": "Pre-approved",
      "COMPLETING": "Completing",
      "PENDING_REVIEW": "Pending Review",
      "APPROVED": "Approved",
      "REJECTED": "Rejected",
      "REVOKED": "Revoked"
    }
  },
  "buyerStrikes": {
    "title": "Buyer Strikes",
    "lookupPlaceholder": "User",
    "searchUserPlaceholder": "Search by username...",
    "clear": "Clear Strike",
    "confirmClear": "Are you sure you want to clear this strike?",
    "clearReasonPlaceholder": "Explain why the penalty is cancelled (at least 5 characters)…"
  },
  "sellerDebts": {
    "title": "Seller Debts",
    "filterSeller": "Seller",
    "searchSellerPlaceholder": "Search by username...",
    "totalOutstanding": "Total outstanding debt",
    "writeOff": "Write Off",
    "confirmWriteOff": "Are you sure you want to write off this debt? This action cannot be undone.",
    "writeOffReasonPlaceholder": "Explain the reason for this write-off (minimum 5 characters)...",
    "loadError": "Failed to load seller debts.",
    "status": {
      "OUTSTANDING": "Outstanding",
      "RESOLVED": "Resolved",
      "WRITTEN_OFF": "Written off"
    },
    "toast": {
      "writtenOff": "Debt written off"
    }
  },
  "orders": {
    "title": "Order Management",
    "detail": "Order Detail",
    "orderPrefix": "Order",
    "searchPlaceholder": "Search by order number or buyer...",
    "ordersFound": "{{count}} order(s) found",
    "allStatuses": "All Statuses",
    "allSources": "All Sources",
    "cancelOrder": "Cancel Order",
    "markDelivered": "Mark Delivered",
    "confirmCancel": "Are you sure you want to cancel this order? This action cannot be undone.",
    "confirmDeliver": "Are you sure you want to mark this order as delivered?",
    "cancelSuccess": "Order cancelled successfully",
    "deliverSuccess": "Order marked as delivered",
    "actionFailed": "Action failed",
    "loadError": "Failed to load order details",
    "cancelReason": "Cancel reason",
    "cancelReasons": {
      "fullyRefunded": "Order fully refunded",
      "expired": "Payment not completed in time, order expired",
      "paymentFailed": "Payment failed"
    },
    "pending": "Pending",
    "timeline": "Timeline",
    "timelineCreated": "Created",
    "timelineConfirmed": "Confirmed",
    "timelineShipped": "Shipped",
    "timelineDelivered": "Delivered",
    "timelineCancelled": "Cancelled",
    "buyerAndShop": "Buyer & Shop",
    "buyer": "Buyer",
    "shop": "Shop",
    "items": "Items",
    "qty": "Qty",
    "amounts": "Amounts",
    "subtotal": "Subtotal",
    "shipping": "Shipping",
    "platformFee": "Platform Fee",
    "total": "Total",
    "delivery": "Delivery",
    "carrier": "Carrier",
    "trackingNumber": "Tracking Number",
    "trackingLink": "Tracking Link",
    "trackOrder": "Track order",
    "deliveryMethod": "Delivery Method",
    "deliveryPoint": "Relay Point",
    "downloadLabel": "Download Label",
    "labelDownloadFailed": "Failed to download label",
    "shippedAt": "Shipped At",
    "deliveredAt": "Delivered At",
    "shippingAddress": "Shipping Address",
    "status": {
      "PENDING": "Pending",
      "CONFIRMED": "Confirmed",
      "READY_TO_SHIP": "Ready to Ship",
      "SHIPPED": "Shipped",
      "DELIVERED": "Delivered",
      "COMPLETED": "Completed",
      "CANCELED": "Canceled"
    },
    "source": {
      "CART": "Cart",
      "LIVE": "Live"
    },
    "retryInvoices": "Generate Invoices",
    "invoiceRetryLoading": "Generating...",
    "invoiceRetrySuccess": "{{count}} invoice(s) generated",
    "invoiceRetryNone": "No invoices to generate",
    "invoiceResults": "Generation Results",
    "invoiceGenerated": "Generated",
    "invoiceSubmitted": "Submitted to Pennylane",
    "invoiceSkipped": "Skipped",
    "invoiceFailed": "Failed",
    "invoiceNotApplicable": "Not Applicable",
    "invoiceRequiresReview": "Manual review required",
    "retryPennylane": "Generate PDFs",
    "pennylaneRetryLoading": "Generating...",
    "pennylaneRetrySuccess": "{{count}} invoice(s) processed",
    "pennylaneRetryFailed": "{{count}} invoice(s) failed",
    "pennylaneRetryNone": "No invoices to process",
    "pennylaneRetryRequiresReview": "{{count}} invoice(s) require manual PDP review. No new draft was created.",
    "invoiceType": {
      "BUYER_FEE_INVOICE": "Buyer Fee Invoice",
      "SELLER_CUSTOMER_INVOICE": "Seller Customer Invoice",
      "SELLER_FEE_INVOICE": "Seller Fee Invoice"
    },
    "invoices": "Invoices",
    "invoicesNone": "No invoices for this order",
    "invoicesLoadError": "Failed to load invoices",
    "invoiceNumber": "Number",
    "invoiceStatus": {
      "PENDING": "Pending",
      "GENERATED": "Generated",
      "FAILED": "Failed",
      "SUBMITTED_TO_PDP": "Submitted to PDP",
      "ACCEPTED_BY_PDP": "Accepted by PDP",
      "REJECTED_BY_PDP": "Rejected by PDP"
    },
    "invoiceHt": "Excl. tax",
    "invoiceVat": "VAT",
    "invoiceVatRate": "VAT rate",
    "invoiceTotal": "Total incl. tax",
    "invoiceDownload": "Download PDF",
    "invoiceCreatedAt": "Created on",
    "invoiceLineItems": "Line Items",
    "invoiceLineDescription": "Description",
    "invoiceLineQty": "Qty",
    "invoiceLineUnitPrice": "Unit price",
    "invoiceLineVat": "VAT",
    "invoiceLineTotal": "Total",
    "invoiceSubtotalHt": "Subtotal excl. tax",
    "invoiceTotalVat": "Total VAT",
    "invoiceTotalTtc": "Total incl. tax",
    "invoiceLegalMention": "Legal mention",
    "invoiceNoLineItems": "No line items",
    "invoiceToggleDetail": "Details"
  },
  "lives": {
    "title": "Lives",
    "detail": "Live Detail",
    "searchPlaceholder": "Search by title or seller...",
    "livesFound": "{{count}} live(s) found",
    "forceStop": "Force Stop",
    "allStatuses": "All Statuses",
    "shop": "Shop",
    "seller": "Seller",
    "user": "User",
    "generalInfo": "General Information",
    "category": "Category",
    "entryPoint": "Entry Point",
    "notification": "Notification",
    "followers": "Followers",
    "participants": "Participants",
    "peakViewers": "Peak Viewers",
    "createdAt": "Created At",
    "planning": "Planning",
    "statusLabel": "Status",
    "scheduledDate": "Scheduled Date",
    "startedDate": "Started Date",
    "endedDate": "Ended Date",
    "media": "Media",
    "coverImage": "Cover Image",
    "presentationVideo": "Presentation Video",
    "presentationVideoId": "Video ID",
    "items": "Items",
    "itemImage": "Image",
    "itemName": "Name",
    "itemType": "Type",
    "itemStatus": "Status",
    "itemPrice": "Price",
    "itemCurrentPrice": "Current Price",
    "itemBids": "Bids",
    "itemStarted": "Started",
    "streaming": "Streaming",
    "streamingStatus": "Streaming Status",
    "orchestratorLiveId": "Orchestrator Live ID",
    "hlsUrl": "HLS URL",
    "cdnHlsUrl": "CDN HLS URL",
    "vodUrl": "VOD URL",
    "hlsMode": "HLS Mode",
    "streamMonitor": "Live Stream Monitor",
    "dvrLive": "Live Rewind (DVR)",
    "replay": "Live Replay",
    "streamLoading": "Loading stream...",
    "streamUnavailable": "Stream unavailable",
    "streamRetry": "Retry",
    "lastRefreshed": "Refreshed {{seconds}}s ago",
    "forceStopConfirmTitle": "Force Stop Live",
    "forceStopConfirmMessage": "Are you sure you want to force stop the live \"{{title}}\"? This will immediately end the broadcast for all viewers.",
    "webrtc": {
      "label": "Viewer WebRTC stream",
      "help": "On: viewers get a sub-second stream (up to 160 concurrent, beyond which they fall back to LL-HLS automatically). Off: all viewers use LL-HLS (~3-5s latency, unlimited CDN delivery). Broadcasters are never affected.",
      "disabledHint": "Editable only while the live is not finished.",
      "enabled": "Viewer WebRTC stream enabled",
      "disabled": "Viewer WebRTC stream disabled",
      "failed": "Failed to update the viewer WebRTC stream"
    },
    "webrtcGlobal": {
      "title": "Viewer transport (global)",
      "mode": {
        "auto": "Auto",
        "force_on": "Force WebRTC",
        "force_off": "Force LL-HLS"
      },
      "autoHelp": "Auto: each live follows its own WebRTC setting. This is the default mode.",
      "force_onHelp": "Force WebRTC: all lives are forced to sub-second WebRTC (up to 160 viewers/node, beyond which they fall back to LL-HLS automatically).",
      "force_offHelp": "Force LL-HLS (kill-switch): all lives are forced to LL-HLS and already-connected WebRTC viewers are evicted immediately.",
      "evictionWarning": "Force LL-HLS immediately evicts connected WebRTC viewers. Platform-wide action.",
      "confirm": {
        "title": "Change global viewer transport",
        "apply": "Apply",
        "force_onMessage": "Force ALL lives to WebRTC? This applies platform-wide (automatic LL-HLS fallback beyond 160 viewers per node).",
        "force_offMessage": "Force ALL lives to LL-HLS? This cuts WebRTC platform-wide and immediately evicts every currently connected WebRTC viewer."
      },
      "updated": "Global viewer transport updated",
      "updateFailed": "Failed to update the global viewer transport",
      "loadFailed": "Failed to load the global viewer transport"
    },
    "chat": {
      "loading": "Loading messages...",
      "empty": "No messages yet",
      "moderated": "MODERATED",
      "reason": "Reason",
      "showOriginal": "Show original message",
      "hideOriginal": "Hide original",
      "confirmHide": "Hide this message?",
      "confirmBan": "Ban {{username}}?",
      "hideTooltip": "Hide message",
      "banTooltip": "Ban user from chat",
      "unhide": "Unhide",
      "muteTooltip": "Mute user",
      "ejectTooltip": "Eject from live",
      "muteDuration": "Mute for:",
      "confirmEject": "Eject {{username}}?",
      "loadOlder": "Load older messages"
    },
    "tabInfo": "Info",
    "tabChat": "Chat",
    "tabSales": "Sales",
    "tabBans": "Bans",
    "bannedUsers": "Banned Users",
    "bannedUser": "User",
    "bannedByLabel": "Banned by",
    "bannedDate": "Date",
    "noBannedUsers": "No banned users for this shop",
    "shopLevel": "Shop-level",
    "unban": "Unban",
    "activeSale": "Active Sale",
    "soldItemsSection": "Sold Items",
    "queuedItems": "Queued Items",
    "status": {
      "LIVE": "Live",
      "SCHEDULED": "Scheduled",
      "DRAFT": "Draft",
      "DONE": "Done"
    }
  },
  "discounts": {
    "title": "Discounts",
    "createDiscount": "Create Discount",
    "code": "Code",
    "description": "Description",
    "type": "Type",
    "amount": "Amount",
    "minOrderAmount": "Min Order Amount",
    "value": "Value",
    "maxUses": "Max Uses",
    "startsAt": "Starts At",
    "expiresAt": "Expires At",
    "disable": "Disable",
    "enable": "Enable",
    "disableConfirmTitle": "Disable discount",
    "disableConfirmMessage": "Disable discount code {{code}}? It will no longer be usable at checkout.",
    "cannotEnableExpired": "This discount has expired and cannot be re-enabled.",
    "toast": {
      "created": "Discount created",
      "validationError": "Please fill in all required fields",
      "disabled": "Discount disabled",
      "enabled": "Discount enabled"
    }
  },
  "referralCampaigns": {
    "title": "Referral Campaigns",
    "create": "Create Campaign",
    "detail": "Campaign Detail",
    "edit": "Edit Campaign",
    "deactivate": "Deactivate",
    "userId": "User",
    "searchUserPlaceholder": "Search by username...",
    "referrerAmount": "Referrer Amount",
    "refereeAmount": "Referee Amount",
    "minQualifyingOrder": "Min Qualifying Order",
    "maxReferralsPerMonth": "Max Referrals/Month",
    "lifetimeMaxReferrals": "Lifetime Max Referrals",
    "startsAt": "Starts At",
    "endsAt": "Ends At",
    "toast": {
      "deleted": "Campaign deleted",
      "deleteFailed": "Failed to delete campaign"
    }
  },
  "categories": {
    "title": "Categories",
    "category": "Category",
    "label": "Label",
    "shortName": "Short Name",
    "pictureUrl": "Picture URL",
    "position": "Position",
    "isOnboarding": "Onboarding",
    "parentCategory": "Parent Category",
    "noParent": "None (root category)",
    "parentHint": "Leave empty to create a root category.",
    "addCategory": "Add Category",
    "editCategory": "Edit Category",
    "addCondition": "Add Condition",
    "addWeight": "Add Weight",
    "weight": "Weight",
    "toggle": "Toggle Active",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "name": "Name",
    "slug": "Slug",
    "active": "Active",
    "empty": "No categories loaded. Create one to get started.",
    "edit": {
      "upload": {
        "title": "Upload an image",
        "currentImageAlt": "Current category image",
        "noImage": "No image",
        "successToast": "Image uploaded"
      }
    }
  },
  "shared": {
    "imageUpload": {
      "title": "Upload an image",
      "hint": "PNG, JPEG or WEBP, max 5 MB",
      "uploading": "Uploading...",
      "openPicker": "Open file picker",
      "errors": {
        "invalidType": "Unsupported file type. Use PNG, JPEG or WEBP.",
        "tooLarge": "File too large. Maximum 5 MB.",
        "network": "Upload failed. Please try again."
      }
    }
  },
  "deliveryCarriers": {
    "title": "Delivery Carriers",
    "list": "Active Carriers",
    "upsert": "Add Carrier",
    "editCarrier": "Edit Carrier",
    "carrier": "Carrier",
    "carrierName": "Carrier Name",
    "carrierCode": "Carrier Code",
    "pictureUrl": "Picture URL",
    "position": "Position",
    "active": "Active",
    "mandatory": "Mandatory",
    "required": "Required",
    "codeReadonly": "Carrier code cannot be changed after creation.",
    "empty": "No carriers yet.",
    "shippingRates": "Shipping Rates",
    "syncShippingRates": "Sync Shipping Rates",
    "syncShippingRatesDescription": "Synchronize shipping rates from Sendcloud. This operation may take a few minutes.",
    "syncing": "Syncing...",
    "syncSuccess": "Sync complete: {{synced}} rate(s) synced, {{deleted}} deleted",
    "syncError": "Failed to sync shipping rates",
    "viewShippingRates": "View Shipping Rates"
  },
  "shippingRates": {
    "title": "Shipping Rates",
    "ratesFound": "{{count}} rate(s) found",
    "allCarriers": "All Carriers",
    "allFromCountries": "All Origin Countries",
    "allToCountries": "All Destination Countries",
    "sync": "Synchronization",
    "syncDescription": "Synchronize shipping rates from Sendcloud. This operation may take a few minutes.",
    "backToCarriers": "Back to Carriers",
    "syncDispatched": "Sync job dispatched — rates will update shortly",
    "showing": "Showing {{displayed}} of {{total}}",
    "loadMore": "Load more"
  },
  "searchAdmin": {
    "title": "Search Administration",
    "reindex": "Reindex",
    "analytics": "Analytics",
    "sourceType": "Source Type",
    "triggerReindex": "Trigger Reindex",
    "trending": "Trending Searches",
    "topClicked": "Top Clicked",
    "reindexWarning": "This will rebuild the search index. It may take several minutes and temporarily affect search results.",
    "sourceItems": "Items",
    "sourceShops": "Shops",
    "confirmReindex": "Are you sure you want to reindex {{sourceType}}? This may take several minutes.",
    "loadError": "Failed to load search analytics",
    "reindexTriggered": "Reindex triggered",
    "reindexFailed": "Reindex failed",
    "noTrending": "No trending queries yet.",
    "noClickData": "No click data yet.",
    "sourceLives": "Lives"
  },
  "reconciliation": {
    "title": "Reconciliation",
    "runs": "Reconciliation Runs",
    "runNow": "Run Now",
    "detail": "Run Details",
    "discrepancies": "Discrepancies",
    "runId": "Run ID",
    "startedAt": "Started At",
    "completedAt": "Completed At",
    "confirmRun": "Are you sure you want to trigger a reconciliation run? This will compare all payment records with Stripe.",
    "runStarted": "Reconciliation started",
    "runFailed": "Failed to start reconciliation"
  },
  "messages": {
    "title": "Messaging",
    "tabs": {
      "browse": "Browse",
      "search": "Search"
    }
  },
  "flaggedQueue": {
    "title": "Flagged Content Queue",
    "allTypes": "All Types",
    "minReports": "Min {{count}} report(s)",
    "pendingCount": "{{count}} item(s) pending review",
    "colType": "Type",
    "colContent": "Content",
    "colOwner": "Owner",
    "colReports": "Reports",
    "colLatest": "Latest Report",
    "colStatus": "Status",
    "empty": "No flagged content. All clear!",
    "hide": "Hide",
    "dismiss": "Dismiss",
    "hideContent": "Hide this content",
    "dismissAll": "Dismiss all reports",
    "viewReports": "View Reports",
    "confirmHideTitle": "Hide Content",
    "confirmHideMessage": "Are you sure you want to hide this content? This will mark it as hidden and resolve all associated reports.",
    "confirmDismissTitle": "Dismiss Reports",
    "confirmDismissMessage": "Are you sure you want to dismiss all reports for this content? The content will remain visible.",
    "hiddenSuccess": "Content hidden successfully",
    "dismissedSuccess": "Reports dismissed",
    "type": {
      "MESSAGE": "Message",
      "LIVE_MESSAGE": "Live Message",
      "COMMENT": "Comment",
      "ITEM": "Item",
      "LIVE": "Live",
      "REVIEW": "Review"
    }
  },
  "conversations": {
    "title": "Conversations",
    "detail": "Conversation Detail",
    "searchPlaceholder": "Search by user ID or username...",
    "filterByType": "Filter by type",
    "participants": "Participants",
    "type": "Type",
    "lastMessage": "Last Message",
    "lastMessageDate": "Last Message Date",
    "messageCount": "Messages",
    "messagesLabel": "messages",
    "messages": "Messages",
    "createdAt": "Created",
    "info": "Conversation Info",
    "noMessages": "No messages in this conversation.",
    "loadOlder": "Load older messages",
    "hidden": "Hidden",
    "hiddenBy": "Hidden by",
    "showOriginal": "Show original",
    "hideOriginal": "Hide original",
    "hideMessage": "Hide Message",
    "hideMessageTitle": "Hide Message",
    "hideMessageConfirm": "Are you sure you want to hide this message? The sender will no longer see it.",
    "hideReasonPlaceholder": "Enter the reason for hiding this message...",
    "hideSuccess": "Message hidden successfully",
    "unhide": "Unhide",
    "unhideSuccess": "Message restored successfully",
    "selectMessages": "Select",
    "cancelSelection": "Cancel selection",
    "selectedCount": "{{count}} message(s) selected",
    "selectAll": "Select all visible",
    "clearSelection": "Clear",
    "hideSelected": "Hide selected",
    "bulkHideTitle": "Hide Selected Messages",
    "bulkHideConfirm": "Are you sure you want to hide {{count}} selected message(s)? The senders will no longer see them.",
    "bulkHideSuccess": "{{count}} message(s) hidden successfully",
    "emptyTitle": "No conversations found",
    "emptyDescription": "Try searching by user ID or username, or adjust the type filter.",
    "type.BUYER_SHOP": "Buyer-Shop",
    "type.USER_USER": "User-User",
    "type.GROUP": "Group"
  },
  "messageSearch": {
    "title": "Message Search",
    "placeholder": "Search messages by content...",
    "content": "Content",
    "sender": "Sender",
    "source": "Source",
    "status": "Status",
    "date": "Date",
    "emptyTitle": "No messages found",
    "emptyDescription": "Try a different search query."
  },
  "queues": {
    "title": "Queue Management",
    "lastUpdated": "Last updated:",
    "refresh": "Refresh",
    "healthyQueues": "Healthy",
    "degradedQueues": "Degraded",
    "totalFailed": "Total Failed",
    "pausedQueues": "Paused",
    "scheduledJobs": "Scheduled Jobs",
    "eventDrivenQueues": "Event-Driven Queues",
    "noScheduledQueues": "No scheduled queues.",
    "noEventDrivenQueues": "No event-driven queues.",
    "critical": "Critical",
    "recovered": "Recovered",
    "stillFailing": "Still Failing",
    "pause": "Pause",
    "resume": "Resume",
    "retryFailed": "Retry Failed",
    "description": "Description",
    "schedule": "Schedule",
    "type": "Type",
    "status": "Status",
    "typeRepeatable": "Scheduled (cron)",
    "typeEventDriven": "Event-driven",
    "failedJobsDetail": "Failed Jobs Detail",
    "loadMoreFailed": "Load more failed jobs",
    "confirmPauseTitle": "Pause Queue",
    "confirmPauseCriticalTitle": "Pause Queue (Critical)",
    "confirmResumeTitle": "Resume Queue",
    "confirmRetryTitle": "Retry Failed Jobs",
    "counter": {
      "active": "Active",
      "waiting": "Waiting",
      "delayed": "Delayed",
      "done": "Done",
      "failed": "Failed"
    },
    "table": {
      "queue": "Queue",
      "jobId": "Job ID",
      "jobName": "Job Name",
      "error": "Error",
      "attempts": "Attempts",
      "failedAt": "Failed At"
    },
    "detail": {
      "errorMessage": "Error Message",
      "stackTrace": "Stack Trace",
      "jobName": "Job Name",
      "jobId": "Job ID",
      "attempts": "Attempts",
      "failedAt": "Failed At"
    },
    "dlq": {
      "title": "Dead Letter Queue",
      "unresolved": "DLQ Unresolved",
      "noEntries": "No dead letter entries.",
      "allQueues": "All Queues",
      "retry": "Retry",
      "resolve": "Resolve",
      "loadMore": "Load More",
      "createdAt": "Created At",
      "payload": "Payload",
      "detailTitle": "Dead Letter Job Detail"
    }
  },
  "shops": {
    "title": "Shops",
    "searchPlaceholder": "Search by shop name...",
    "shopsFound": "shop(s) found",
    "shopInfo": "Shop Information",
    "sellerType": "Seller Type",
    "vatRate": "VAT Rate",
    "followers": "Followers",
    "totalItems": "Total Items",
    "totalOrders": "Total Orders",
    "created": "Created",
    "updated": "Updated",
    "sellerInfo": "Seller Information",
    "stripeInfo": "Stripe Information",
    "chargesEnabled": "Charges Enabled",
    "payoutsEnabled": "Payouts Enabled",
    "shippingAddress": "Shipping Address",
    "street": "Street",
    "city": "City",
    "postalCode": "Postal Code",
    "country": "Country",
    "region": "Region",
    "presentationVideo": "Presentation Video",
    "actions": "Actions",
    "revokeSeller": "Revoke Seller Access",
    "sellerRequestStatus": "Seller Request Status",
    "revokeSuccess": "Seller access revoked",
    "revokeFailed": "Failed to revoke seller access",
    "loadFailed": "Failed to load shop",
    "vacation": "On vacation",
    "vacationStatus": "Vacation mode",
    "vacationSince": "On vacation since",
    "stripeSync": {
      "button": "Resync Stripe",
      "title": "Stripe sync",
      "syncing": "Syncing...",
      "started": "Stripe sync started",
      "confirm": "Update the Stripe status of all shops? The sync runs in the background; you can follow its progress on this page.",
      "confirmLabel": "Start sync",
      "rateLimited": "Too many attempts. Try again in a minute.",
      "failed": "Stripe resync failed. Try again.",
      "empty": "No sync yet.",
      "loadError": "Unable to load the latest sync.",
      "trackingLost": "Tracking interrupted: the status shown may be out of date.",
      "queuedHint": "Waiting to start…",
      "caption": "{{total}} shop(s) checked",
      "captionWithInternal": "{{total}} shop(s) checked, including {{internal}} internal shop(s) without a Stripe Connect account (skipped)",
      "runFailedHint": "The sync stopped before completion ({{processed}} shop(s) processed). Run it again.",
      "failuresTitle": "{{count}} shop(s) in error",
      "failuresHint": "Click a row to open the shop. Stripe error: run the sync again. Account not found: contact the seller.",
      "failuresTruncated": "Only the first {{count}} shops are listed. Run the sync again to reprocess the others.",
      "status": {
        "QUEUED": "Queued",
        "RUNNING": "Running",
        "COMPLETED": "Completed",
        "COMPLETED_WITH_ERRORS": "Completed with errors",
        "FAILED": "Failed"
      },
      "trigger": {
        "ADMIN": "Manual",
        "CRON": "Automatic"
      },
      "meta": {
        "running": "{{trigger}} · started {{date}}",
        "finished": "{{trigger}} · {{date}} · {{duration}}"
      },
      "progress": {
        "label": "Stripe sync progress",
        "counter": "{{processed}} / {{total}} shop(s) processed",
        "counterNoTotal": "{{processed}} shop(s) processed",
        "announce": "Sync in progress: {{percent}}%",
        "announceNoTotal": "Sync in progress"
      },
      "kpi": {
        "updated": "Updated",
        "unchanged": "Already up to date",
        "errors": "In error"
      },
      "col": {
        "shop": "Shop",
        "problem": "Issue"
      },
      "toast": {
        "completed": "Stripe sync completed",
        "completedWithErrors": "Stripe sync completed: {{count}} shop(s) in error"
      },
      "reason": {
        "stripe_account_unavailable": "Account not found at Stripe",
        "stripe_lookup_failed": "Stripe error, retry",
        "shop_update_failed": "Update failed",
        "unknown": "Unknown reason"
      }
    }
  },
  "toast": {
    "success": "Success",
    "error": "Error",
    "warning": "Warning",
    "info": "Information"
  },
  "adminActions": {
    "title": "Admin Actions",
    "searchPlaceholder": "Search by target ID...",
    "actionsFound": "{{count}} action(s) found",
    "allActions": "All Actions",
    "allTargets": "All Targets",
    "action": "Action",
    "targetType": "Target Type",
    "targetId": "Target ID",
    "reason": "Reason",
    "admin": "Admin",
    "date": "Date",
    "dateTo": "to",
    "facetsLoadFailed": "Could not load filters. Existing filters remain available.",
    "close": "Close",
    "metadata": "Metadata",
    "ipAddress": "IP address",
    "userAgent": "User agent",
    "viewDetails": "Click a row to see its details.",
    "noReason": "No reason provided",
    "actionLabels": {
      "SELLER_ACCESS_REVOKED": "Seller access revoked",
      "SELLER_REQUEST_SENT_BACK": "Seller request sent back",
      "SELLER_REQUEST_REJECTED": "Seller request rejected",
      "SELLER_REQUEST_APPROVED": "Seller request approved",
      "SELLER_REQUEST_PRE_APPROVED": "Seller request pre-approved",
      "SHOP_SELLER_REVOKED": "Seller removed from shop",
      "ORDER_DELIVERED": "Order marked delivered",
      "ORDER_CANCELLED": "Order cancelled",
      "ORDER_PENNYLANE_SUBMISSION_RETRIED": "Order Pennylane submission retried",
      "ORDER_INVOICES_RETRIED": "Order invoices retried",
      "REFERRAL_CAMPAIGN_CREATED": "Referral campaign created",
      "REFERRAL_CAMPAIGN_UPDATED": "Referral campaign updated",
      "REFERRAL_CAMPAIGN_DEACTIVATED": "Referral campaign deactivated",
      "USER_MESSAGING_BANNED": "User banned from messaging",
      "USER_MESSAGING_UNBANNED": "User unbanned from messaging",
      "USER_SUSPENDED": "User suspended",
      "USER_REACTIVATED": "User reactivated",
      "USER_BANNED": "User banned",
      "ADMIN_ROLE_GRANTED": "Admin role granted",
      "ADMIN_ROLE_REVOKED": "Admin role revoked",
      "COMMENT_HIDDEN": "Comment hidden",
      "LIVE_TERMINAL_EVENT_REQUEUED": "Live terminal event requeued",
      "RECONCILIATION_TRIGGERED": "Reconciliation triggered",
      "CATEGORY_CREATED": "Category created",
      "CATEGORY_UPDATED": "Category updated",
      "CATEGORY_TOGGLED": "Category toggled",
      "WEIGHT_CREATED": "Weight created",
      "CONDITION_CREATED": "Condition created",
      "SHOP_SUSPENDED": "Shop suspended",
      "SHOP_UNSUSPENDED": "Shop unsuspended",
      "MESSAGE_HIDDEN": "Message hidden",
      "MESSAGES_BULK_HIDDEN": "Messages bulk hidden",
      "MESSAGE_UNHIDDEN": "Message unhidden",
      "BUYER_STRIKE_CLEARED": "Buyer strike cleared",
      "DISCOUNT_CREATED": "Discount created",
      "DISCOUNT_ENABLED": "Discount enabled",
      "DISCOUNT_DISABLED": "Discount disabled",
      "SEARCH_REINDEX_TRIGGERED": "Search reindex triggered",
      "ITEM_AUCTION_FORCE_ENDED": "Auction force ended",
      "ITEM_FLAG_CLEARED": "Item flag cleared",
      "ITEM_FLAGGED": "Item flagged",
      "ITEM_ADMIN_REPUBLISHED": "Item republished by admin",
      "ITEM_ADMIN_UNPUBLISHED": "Item unpublished by admin",
      "ITEM_ADMIN_EDITED": "Item edited by admin",
      "ITEM_ADMIN_FORCE_DELETED": "Item force deleted by admin",
      "ITEM_GIVEAWAY_FORCE_DRAWN": "Giveaway force drawn",
      "ITEM_FORCE_LAUNCHED": "Item force launched",
      "REVIEW_HIDDEN": "Review hidden",
      "REVIEW_REPUBLISHED": "Review republished",
      "REVIEW_REJECTED": "Review rejected",
      "LIVE_FORCE_STOPPED": "Live force stopped",
      "VIEWER_MUTED": "Viewer muted",
      "VIEWER_UNMUTED": "Viewer unmuted",
      "VIEWER_EJECTED": "Viewer ejected",
      "LIVE_MESSAGE_HIDDEN": "Live message hidden",
      "LIVE_MESSAGE_UNHIDDEN": "Live message unhidden",
      "SELLER_DEBT_WRITTEN_OFF": "Seller debt written off",
      "WALLET_CREDITED": "Wallet credited by admin",
      "DELIVERY_CARRIER_UPSERTED": "Delivery carrier upserted",
      "REPORT_DISMISSED": "Report dismissed",
      "REPORT_ADMIN_NOTE_SET": "Report admin note set",
      "REPORT_RESOLVED": "Report resolved",
      "REPORT_REVIEW_STARTED": "Report review started",
      "FLAGGED_CONTENT_HIDDEN": "Flagged content hidden",
      "FLAGGED_CONTENT_DISMISSED": "Flagged content dismissed",
      "SUPPORT_TICKET_REPLIED": "Support ticket replied",
      "SUPPORT_TICKET_STATUS_CHANGED": "Support ticket status changed",
      "PAYMENT_REFUNDED": "Payment refunded",
      "LIVE_VIEWER_BANNED": "Live viewer banned",
      "LIVE_VIEWER_MUTED": "Viewer muted in shop",
      "LIVE_VIEWER_UNBANNED": "Live viewer unbanned",
      "LIVE_SHOP_BAN_LIFTED": "Live shop ban lifted",
      "SHOP_SLUG_CHANGED": "Shop slug changed",
      "PRODUCT_REQUEST_ENRICHED": "Product request enriched",
      "PRODUCT_REQUEST_VALIDATED": "Product request validated",
      "PRODUCT_REQUEST_REJECTED": "Product request rejected",
      "QUEUE_PAUSED": "Queue paused",
      "QUEUE_RESUMED": "Queue resumed",
      "QUEUE_FAILED_JOBS_RETRIED": "Queue failed jobs retried",
      "DEAD_LETTER_JOB_RESOLVED": "Dead letter job resolved",
      "DEAD_LETTER_JOB_RETRIED": "Dead letter job retried",
      "FAILED_EVENT_REPLAYED": "Failed event replayed",
      "INVOICE_PDP_PA_REVIEW_RECOVERED": "Invoice PDP/PA review recovered",
      "INVOICE_PDP_SUBMISSION_REVIEW_RECOVERED": "Invoice PDP submission review recovered",
      "NOTIFICATION_DELIVERY_SWITCHED": "Notification delivery switched",
      "LIVE_HLS_DELAY_SET": "Live HLS delay set",
      "LIVE_HLS_DELAY_CLEARED": "Live HLS delay cleared",
      "LIVE_WEBRTC_GLOBAL_MODE_SET": "Live WebRTC global mode set",
      "LIVE_STREAMING_URLS_SET": "Live streaming URLs set",
      "LIVE_VIEWER_WEBRTC_SET": "Live viewer WebRTC set",
      "LIVE_STREAMING_URLS_SYNCED": "Live streaming URLs synced",
      "ORCHESTRATOR_JOB_RETRIED": "Orchestrator job retried",
      "ORCHESTRATOR_NODE_DELETED": "Orchestrator node deleted",
      "TCG_GAME_CREATED": "TCG game created",
      "TCG_GAME_TOGGLED": "TCG game toggled",
      "TCG_INGESTION_TRIGGERED": "TCG ingestion triggered",
      "SHIPPING_RATES_SYNCED": "Shipping rates synced",
      "STRIPE_CONNECT_SYNCED": "Stripe Connect synced",
      "SELLER_REQUEST_STRIPE_CONNECT_SET": "Stripe Connect account set on seller request",
      "DISCORD_ACCOUNT_FORCE_UNLINKED": "Discord account disconnected by the team",
      "DISCORD_TICKET_ERASED_EARLY": "Discord ticket permanently deleted"
    },
    "targetLabels": {
      "SELLER_REQUEST": "Seller request",
      "SHOP": "Shop",
      "ORDER": "Order",
      "REFERRAL_CAMPAIGN": "Referral campaign",
      "USER": "User",
      "COMMENT": "Comment",
      "RECONCILIATION": "Reconciliation",
      "LIVE_TERMINAL_EVENT": "Live terminal event",
      "CATEGORY": "Category",
      "WEIGHT": "Weight",
      "CONDITION": "Condition",
      "MESSAGE": "Message",
      "DISCOUNT": "Discount",
      "SEARCH": "Search",
      "ITEM": "Item",
      "REVIEW": "Review",
      "LIVE": "Live",
      "LIVE_MESSAGE": "Live message",
      "SELLER_DEBT": "Seller debt",
      "DELIVERY_CARRIER": "Delivery carrier",
      "REPORT": "Report",
      "BUYER_STRIKE": "Buyer strike",
      "SUPPORT_TICKET": "Support ticket",
      "PAYMENT": "Payment",
      "PRODUCT_REQUEST": "Product request",
      "QUEUE": "Queue",
      "DEAD_LETTER_JOB": "Dead letter job",
      "FAILED_EVENT": "Failed event",
      "INVOICE": "Invoice",
      "PLATFORM": "Platform",
      "STRIPE_CONNECT_ACCOUNT": "Stripe Connect account",
      "ORCHESTRATOR_JOB": "Orchestrator job",
      "ORCHESTRATOR_NODE": "Orchestrator node",
      "TCG_GAME": "TCG game"
    }
  },
  "launchStatus": {
    "title": "Launch Status",
    "description": "Go/no-go overview for launch day.",
    "refresh": "Refresh",
    "refreshing": "Refreshing",
    "stale": "Stale data",
    "loadFailed": "Failed to load launch status.",
    "info": "Info",
    "comingSoon": "coming soon",
    "noQueues": "No queues reported.",
    "overall": {
      "GO": "GO",
      "GOHint": "All systems nominal.",
      "WARN": "WARN",
      "WARNHint": "Degraded signals -- keep an eye on it.",
      "NOGO": "NO-GO",
      "NOGOHint": "Critical signals -- do not launch."
    },
    "status": {
      "ok": "OK",
      "warn": "Warning",
      "crit": "Critical"
    },
    "signals": {
      "errors5xx": "5xx errors",
      "serviceUnavailable": "503 responses (load shedding)",
      "liveTotalChanged": "Purchases refused (total changed)",
      "wsAuthority": "Live connection verification",
      "dbPool": "DB connection pool",
      "queues": "Queues",
      "stuckPayouts": "Stuck payouts",
      "payments": "Payments",
      "walletDrift": "Wallet drift",
      "p95Latency": "p95 latency",
      "liveViewers": "Live viewers"
    },
    "metric": {
      "count": "Count",
      "window": "Window",
      "waiting": "Waiting",
      "total": "Total",
      "idle": "Idle",
      "succeeded": "Succeeded",
      "failed": "Failed",
      "value": "Value",
      "refused": "Refused",
      "accepted": "Accepted",
      "livesAtRisk": "Lives at risk",
      "degradedAdmissions": "Admitted without full check",
      "missingVerdictRefusals": "Web clients refused",
      "doubleOutageRefusals": "Refused (database and cache)",
      "redisChecksDeferred": "Checks deferred (cache)",
      "checksPostponed": "Checks running late",
      "pendingSqlVerifications": "Awaiting full check",
      "outboxLag": "Sign-out lag"
    },
    "hints": {
      "serviceUnavailable": "The site is refusing traffic to protect itself (overload, database or cache saturated) or because an external service (payment, shipping, video) is not responding. Buyers see an unavailable price.",
      "liveTotalChanged": "Buyers are refused because the displayed total no longer matches the server's. A high share of refusals prevents buying.",
      "wsAuthority": "When the database or the security cache stops answering, live connections are checked with fewer guarantees. A banned account can then stay in the live."
    },
    "relative": {
      "justNow": "just now",
      "seconds": "{{n}}s ago",
      "minutes": "{{n}}min ago",
      "hours": "{{n}}h ago",
      "days": "{{n}}d ago"
    }
  },
  "system": {
    "title": "System Health",
    "heartbeats": "System Heartbeats",
    "noHeartbeats": "No heartbeat data available.",
    "state": {
      "OK": "OK",
      "DEGRADED": "Degraded",
      "ERROR": "Error",
      "LATE": "Late"
    },
    "hint": {
      "DEGRADED": "The job runs but something does not move forward. See the details below, the alerts and the runbook.",
      "ERROR": "The last run failed. See the API logs and the alerts.",
      "LATE": "The expected run did not happen: the job has probably stopped. See the API logs and the alerts."
    },
    "lastPass": {
      "OK": "Its last run ended well.",
      "DEGRADED": "Its last run was degraded: something did not move forward.",
      "ERROR": "Its last run had failed."
    },
    "jobs": {
      "discord-ticket-sync": "Discord bridge: thread reading",
      "discord-ticket-retention": "Discord bridge: thread retention",
      "discord-live-announce": "Discord Live announcements: daily pass",
      "discord-role-sync": "Discord roles: daily pass",
      "support-ticket-inactivity": "Support: automatic closing",
      "support-ticket-retention": "Support: ticket retention"
    },
    "metadata": {
      "polled": "Threads read",
      "imported": "Messages imported",
      "delivered": "Replies posted",
      "refused": "Replies refused",
      "failed": "Failed",
      "refreshFailed": "Previews and reactions failed",
      "budgetExhausted": "Cycle budget exhausted",
      "skipped": "Run skipped",
      "examined": "Tickets examined",
      "reminded": "Reminders",
      "closed": "Tickets closed",
      "emailSkipped": "Email not swept",
      "discordSkipped": "Discord not swept",
      "erased": "Tickets erased",
      "alreadyErased": "Already erased",
      "deferred": "Deferred",
      "moreExpired": "More left to erase",
      "stuck": "Stuck"
    },
    "metadataValue": {
      "BRIDGE_STOPPED": "bridge safety stop, no more calls to Discord"
    },
    "lastRun": "Last run",
    "nextExpected": "Next expected:",
    "incidents": "Sweep Incidents",
    "noIncidents": "No incidents recorded -- the safety net hasn't needed to intervene.",
    "incidentDate": "Date",
    "incidentType": "Type",
    "incidentItems": "Items Processed",
    "incidentErrors": "Errors",
    "incidentDuration": "Duration",
    "incidentItemIds": "Item IDs",
    "loadMore": "Load More",
    "showLess": "show less",
    "more": "more"
  },
  "nodes": {
    "title": "Nodes",
    "detail": "Node Detail",
    "refresh": "Refresh",
    "nodeInfo": "Node Information",
    "statusLabel": "Status",
    "ip": "IP Address",
    "serverType": "Server Type",
    "hetznerId": "Hetzner ID",
    "dnsRecordId": "DNS Record ID",
    "billingHourStart": "Billing Hour Start",
    "createdAt": "Created At",
    "destroyedAt": "Destroyed At",
    "lives": "Lives on this Node",
    "noLives": "No lives have been assigned to this node.",
    "eventLog": "Event Log",
    "noEvents": "No events recorded for this node.",
    "metadata": "Metadata",
    "hetznerActions": "Hetzner Server Actions",
    "noHetznerActions": "No Hetzner actions available (server may have been deleted).",
    "deleteConfirmTitle": "Delete Node",
    "deleteConfirmMessage": "Are you sure you want to remove node \"{{id}}\"? This will terminate the server instance.",
    "deleteSuccess": "Node deleted",
    "deleteFailed": "Failed to delete node",
    "loadFailed": "Failed to load node data"
  },
  "confirmDialog": {
    "title": "Confirm Action",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "reasonLabel": "Reason",
    "reasonPlaceholder": "Explain the reason for this action (minimum 10 characters)...",
    "reasonMinLength": "Minimum {{min}} characters required"
  },
  "infra": {
    "refresh": "Refresh",
    "loadFailed": "Failed to load infrastructure data",
    "overview": {
      "title": "Infrastructure Overview",
      "health": "Health Status",
      "uptime": "Uptime",
      "nodes": "Nodes",
      "lives": "Lives",
      "videos": "Videos",
      "queues": "Queues",
      "noQueues": "No queue data available.",
      "failedJobsAlert": "{{count}} failed job(s) require attention.",
      "viewQueues": "View queues"
    },
    "lives": {
      "title": "Orchestrator Lives",
      "detail": "Live Detail",
      "liveInfo": "Live Information",
      "node": "Assigned Node",
      "streaming": "Streaming URLs",
      "egress": "Egress IDs",
      "thumbnail": "Thumbnail",
      "notFound": "Live not found",
      "showing": "Showing {{count}} of {{total}} lives"
    },
    "nodes": {
      "title": "Orchestrator Nodes",
      "detail": "Node Detail",
      "nodeInfo": "Node Information",
      "includeDestroyed": "Include destroyed nodes",
      "eventLog": "Event Log",
      "noEvents": "No events recorded for this node.",
      "notFound": "Node not found"
    },
    "videos": {
      "title": "Orchestrator Videos",
      "showing": "Showing {{count}} of {{total}} videos"
    },
    "queues": {
      "title": "Orchestrator Queues",
      "viewFailed": "View failed jobs",
      "failedJobs": "Failed Jobs",
      "noFailedJobs": "No failed jobs in this queue.",
      "retrySuccess": "Job retried successfully",
      "retryFailed": "Failed to retry job"
    }
  },
  "emails": {
    "title": "Email Templates",
    "refresh": "Refresh",
    "totalTemplates": "Total templates",
    "synced": "Synced",
    "missing": "Missing",
    "noTemplates": "No email templates found.",
    "templateName": "Template Name",
    "description": "Description",
    "brevoId": "Brevo ID",
    "brevoTemplateName": "Brevo Template Name",
    "active": "Active",
    "statusSynced": "Synced",
    "statusMissing": "Missing",
    "statusError": "Error",
    "actions": "Actions",
    "preview": "Preview"
  },
  "tcgReference": {
    "gamesTitle": "TCG Games",
    "createGame": "Create Game",
    "newGame": "New Game",
    "noGames": "No games configured yet.",
    "code": "Code",
    "nameEn": "Name (EN)",
    "nameFr": "Name (FR)",
    "position": "Position",
    "toggleGame": "Toggle game status",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "sync": "Sync",
    "syncGame": "Trigger sync for this game",
    "syncing": "Syncing...",
    "viewDetails": "View details",
    "cards": "cards",
    "setsTab": "Sets",
    "productsTab": "Products",
    "language": "Language",
    "cardInfo": "Card Information",
    "cardName": "Card Name",
    "number": "Number",
    "rarity": "Rarity",
    "attributes": "Attributes",
    "ingestion": {
      "title": "Ingestion Monitoring",
      "sources": "Sources",
      "recentRuns": "Recent Runs",
      "triggerSync": "Trigger Sync",
      "selectSource": "Select source",
      "choosePlaceholder": "Choose a source...",
      "trigger": "Trigger",
      "source": "Source",
      "startedAt": "Started",
      "completedAt": "Completed",
      "created": "Created",
      "updated": "Updated",
      "errors": "Errors",
      "noRuns": "No ingestion runs found.",
      "autoRefresh": "Auto-refreshing while running..."
    },
    "runDetail": {
      "title": "Run Detail",
      "progress": "Progress",
      "processedCards": "Processed Cards",
      "totalCards": "Total Cards",
      "elapsed": "Elapsed",
      "duration": "Duration",
      "results": "Results",
      "updated": "upd",
      "errorsTable": "Errors",
      "noErrors": "No errors",
      "cardName": "Card Name",
      "setCode": "Set Code",
      "errorMessage": "Error Message",
      "runningFor": "Running for",
      "syncCompleted": "Sync completed successfully",
      "syncFailed": "Sync failed"
    }
  },
  "settings": {
    "title": "Settings",
    "appearance": {
      "sectionTitle": "Appearance",
      "light": "Light",
      "lightDescription": "Light theme, white background",
      "dark": "Dark",
      "darkDescription": "Dark theme, easier on the eyes at night",
      "system": "System",
      "systemDescription": "Follows your operating system preference"
    },
    "language": {
      "sectionTitle": "Language",
      "fr": "French",
      "en": "English"
    },
    "discord": {
      "sectionTitle": "Discord account",
      "intro": "Connect your Discord account so that your first name appears, instead of your Discord username, when you write directly in a request thread.",
      "status": {
        "linked": "Connected",
        "notLinked": "Not connected"
      },
      "account": "Discord account",
      "linkedAt": "Connected on",
      "link": "Connect my Discord account",
      "redirecting": "Redirecting to Discord…",
      "redirectHint": "You will be redirected to Discord to authorize Blisterr, then you will come back here to confirm.",
      "unlink": "Disconnect my Discord account",
      "unlinkTitle": "Disconnect your Discord account?",
      "unlinkBody": "Your messages written directly in a request thread will no longer carry your first name, but your Discord username. If you are also a seller or a buyer, your Marchand ✓ and Looteur ✓ roles will be removed from the server. You can reconnect your Discord account whenever you like.",
      "unlinkConfirm": "Disconnect Discord",
      "unlinked": "Your Discord account is disconnected.",
      "linked": "Your Discord account is connected.",
      "loadError": "Unable to load the connection status of your Discord account.",
      "callback": {
        "title": "Connecting your Discord account",
        "loading": {
          "title": "Verification in progress",
          "body": "We are verifying your authorization with Discord. Do not close this page."
        },
        "confirm": {
          "title": "Connect @{{username}}?",
          "account": "Discord account",
          "body": "This Discord account will be connected to your Blisterr account. You can disconnect it at any time.",
          "effect": "Your first name will replace your Discord username on the messages you write directly in a request thread.",
          "roles": "If your account is also a seller or a buyer, you will receive the Marchand ✓ and Looteur ✓ roles, visible to all members of the server. You can hide them at any time from the Blisterr web app (Settings, Connected accounts).",
          "wrongAccount": "Not your account? Cancel, close your Discord session in this browser, reopen it with the right account, then start again.",
          "accept": "Connect @{{username}}",
          "cancel": "Cancel",
          "validity": "This confirmation is valid for 5 minutes."
        },
        "errorTitle": "Connecting your Discord account did not complete",
        "retry": "Try again",
        "back": "Back to settings"
      },
      "error": {
        "denied": "You declined the authorization on Discord. Nothing was connected.",
        "alreadyLinked": "This Discord account is already connected to another Blisterr account. Nothing was connected.",
        "alreadyHasLink": "A Discord account is already connected to your account. Disconnect it first.",
        "invalid": "The link is no longer valid: it has expired or was already used. Nothing was connected.",
        "stagingExpired": "The confirmation has expired. Start connecting your Discord account again.",
        "unlinkInProgress": "Disconnecting your Discord account is in progress. Try again in a few minutes.",
        "blocked": "Connecting a Discord account is suspended on your account. Try again later or contact another administrator.",
        "oauthRejected": "Connecting to Discord is unavailable for now: the Blisterr Discord application is rejected (alert raised). Nothing was connected.",
        "confirmInProgress": "This confirmation is already being processed. Go back to settings to see the connection status of your Discord account.",
        "notLinked": "Your Discord account is no longer connected.",
        "rateLimited": "Too many attempts. Please wait a few minutes before trying again.",
        "unavailable": "Connecting to Discord is temporarily unavailable. Try again in a few minutes.",
        "unknown": "An error occurred. Please try again."
      }
    }
  },
  "support": {
    "title": "Support",
    "detail": "Ticket Detail",
    "requester": "Requester",
    "email": "Email",
    "createdAt": "Created",
    "lastMessageAt": "Last message",
    "conversation": "Conversation",
    "noMessages": "No messages",
    "authorCustomer": "Customer",
    "authorAdmin": "Support",
    "authorSystem": "System",
    "replyTitle": "Reply",
    "replyPlaceholder": "Type your reply to the customer...",
    "send": "Send",
    "close": "Close ticket",
    "reopen": "Reopen ticket",
    "filterAll": "All",
    "filterOpen": "Open",
    "filterPending": "Pending",
    "filterClosed": "Closed",
    "replySuccess": "Reply sent to customer",
    "closeSuccess": "Ticket closed",
    "reopenSuccess": "Ticket reopened",
    "replyQueued": "Reply saved: it will be posted in the Discord thread within a few seconds",
    "replyChannelUnavailable": "Reply not sent: the Discord thread for this ticket is unavailable.",
    "filterStatus": "Status",
    "filterChannel": "Channel",
    "channelEmail": "Email",
    "channelDiscord": "Discord",
    "discordNickname": "Discord nickname",
    "authorTeamChannel": "team (Discord)",
    "composer": {
      "counter": "{{count}} / {{max}} characters",
      "nearLimit": "You are close to the limit of {{max}} characters.",
      "overLimit": "Limit of {{max}} characters exceeded: shorten the reply.",
      "disabled": "Replying is impossible: the Discord thread is unavailable."
    },
    "delivery": {
      "sending": "Sending to Discord…",
      "pending": "Not delivered to Discord yet, next attempt at the next cycle",
      "pendingClosed": "Not delivered to Discord (ticket closed, no further attempt)",
      "refused": {
        "BLOCKED_BY_MODERATION": "Refused by Discord: blocked by the server moderation (AutoMod)",
        "FORBIDDEN": "Refused by Discord: the bot lacks permissions on this thread",
        "INVALID": "Refused by Discord: invalid content",
        "CHANNEL_UNAVAILABLE": "Not delivered: the Discord thread is unavailable, this reply will not be sent",
        "UNKNOWN": "Refused by Discord"
      }
    },
    "attachment": {
      "download": "Download: {{name}} ({{size}})",
      "newTab": "(opens in a new tab)",
      "noPreview": "No preview for this format",
      "skipped": "Not kept",
      "failed": "Copy failed",
      "unavailable": "File unavailable",
      "animation": "Looping animation",
      "reason": {
        "UNSUPPORTED_TYPE": "Only images are kept",
        "FILE_TOO_LARGE": "File too large",
        "TOO_MANY_FILES": "Too many files in the same message",
        "MESSAGE_QUOTA_EXCEEDED": "Attachment quota of the message exceeded",
        "TICKET_QUOTA_EXCEEDED": "Attachment quota of the ticket exceeded",
        "COPY_FAILED": "Could not be copied from Discord (expired link or network error)"
      }
    },
    "reaction": {
      "label": "Reactions",
      "team": "(team)",
      "member": "(member)",
      "othersOne": "and {{count}} other",
      "othersMany": "and {{count}} others"
    },
    "notice": {
      "unverified": "This member is not verified. Do not share any account or order data, and do not change anything from this ticket.",
      "issueUnavailable": "The Discord thread is unavailable: your replies can no longer be sent.",
      "issueSetupFailed": "The Discord thread of this request could not be created: your replies cannot be sent.",
      "issueAction": "Ask the member to open a new request from #aide (on the server, never in a private message: the team committed to never send any), then close this ticket.",
      "issueClosed": "The Discord thread of this request is unavailable. The ticket being closed, there is nothing to do.",
      "verified": "This member is verified: their Discord account is connected to their Blisterr account ({{name}}). You may tell them the status and tracking of their orders. Do not share a full address or a payment method, and do not change any account data from this ticket.",
      "restricted": "The Blisterr account connected to this member is {{status}}. Do not share any account or order data.",
      "recent": "This Discord account was connected less than 72 hours ago. Be extra careful.",
      "viewAccount": "View the account page",
      "nameFallback": "first name not set",
      "status": {
        "ACTIVE": "restricted",
        "SUSPENDED": "suspended",
        "BANNED": "banned",
        "DELETED": "deleted"
      }
    },
    "conflict": {
      "message": "This ticket changed during your action (another admin, a new message or a ticket closed in the meantime). Your action was not saved.",
      "replyKept": "The text of your reply is kept.",
      "reloadHint": "Reload the ticket to see its current state, then try again.",
      "refreshedHint": "The ticket has just been refreshed: read it again, then try again.",
      "closedMessage": "This ticket was closed while you were writing your reply. It was not sent.",
      "closedReloadHint": "Copy your text if you want to keep it, reload the ticket, then reopen it if needed to reply.",
      "closedRefreshedHint": "The ticket has just been refreshed: reopen it if needed to reply.",
      "reload": "Reload the ticket",
      "dismiss": "Dismiss this message"
    },
    "accountLine": "Blisterr account",
    "erase": {
      "action": "Erase this ticket",
      "title": "Erase this Discord ticket?",
      "body": "The Discord thread, the attachments and the ticket will be permanently deleted. Enter the reason, it is kept in the actions log.",
      "confirm": "Erase permanently",
      "reasonPlaceholder": "Reason for the erasure (3 to 200 characters)…",
      "erased": "Ticket erased.",
      "alreadyErased": "This ticket was already erased.",
      "errors": {
        "notFound": "This ticket no longer exists.",
        "wrongChannel": "Only a Discord ticket is erased here. An email ticket is erased with the support:erase-ticket command.",
        "notClosed": "This ticket was reopened: it must be closed to be erased. It has just been refreshed.",
        "openingInProgress": "The Discord thread of this ticket is still being opened. Try again in a few moments."
      }
    }
  },
  "errors": {
    "unknown": "Something went wrong. Please try again.",
    "forbidden": "Forbidden: you don't have permission to perform this action.",
    "notFound": "Not found: this item may have been deleted.",
    "conflict": "Conflict: another admin modified this item. Reload the page.",
    "validation": "Validation failed. Check the fields.",
    "validationWithDetail": "Validation failed: {{detail}}",
    "server": "Server error. The team has been notified."
  },
  "refunds": {
    "openButton": "Refund",
    "dialogTitle": "Refund order",
    "dialogSubtitle": "The refund will be credited to the buyer wallet.",
    "amountLabel": "Refund amount",
    "amountHelper": "Maximum: {{max}}",
    "amountTooHigh": "Amount cannot exceed the order total.",
    "amountTooLow": "Amount must be greater than 0.",
    "reasonLabel": "Reason",
    "reasonRequired": "Reason is required.",
    "reason": {
      "litige_buyer": "Buyer dispute",
      "defective_item": "Defective item",
      "no_show_seller": "Seller no-show",
      "other": "Other"
    },
    "noteLabel": "Internal admin note",
    "notePlaceholder": "Internal context, support ticket ID, etc.",
    "includeShipping": "Include shipping fees in refund",
    "confirmTitle": "Confirm refund",
    "confirmSubtitle": "You are about to refund",
    "confirmIrreversible": "This action is irreversible. Amount will be credited to the buyer wallet.",
    "confirmButton": "Confirm refund",
    "back": "Back",
    "submitting": "Refunding...",
    "success": "Refund processed",
    "error": "Refund failed",
    "unavailableNoPayment": "Refund unavailable: the API does not expose an associated payment for this order.",
    "shippingIncludedNote": "Shipping fees included in the refund",
    "errorIdempotencyReuse": "A different refund request already used this key. Reopen the dialog to retry.",
    "errorExceedsTotal": "The amount exceeds the payment's refundable total.",
    "errorNotEligible": "This payment is not eligible for a refund.",
    "errorLiveAttachedToActiveOrder": "This live payment belongs to an order in progress: cancel the order to refund it."
  },
  "reconciliationDiscrepancy": {
    "resolveButton": "Resolve",
    "addNoteButton": "Add note",
    "dialogResolveTitle": "Resolve discrepancy",
    "dialogResolveSubtitle": "Pick a source of truth and document the decision.",
    "resolutionLabel": "Resolution",
    "resolution": {
      "STRIPE_WINS": "Stripe wins (fix DB)",
      "DB_WINS": "DB wins (Stripe is stale)",
      "MANUAL_NOTE": "Manual note (no correction)"
    },
    "noteLabel": "Note",
    "notePlaceholder": "Decision context, ticket link...",
    "noteRequired": "Note is required.",
    "dialogNoteTitle": "Add note",
    "notesTitle": "Notes",
    "noNotes": "No notes yet.",
    "addNote": "Add",
    "submitting": "Saving...",
    "resolveSuccess": "Discrepancy resolved",
    "noteAddedSuccess": "Note added",
    "addedBy": "by",
    "at": "on"
  },
  "liveMessages": {
    "unhide": {
      "notFound": "Message not found.",
      "notHidden": "This message is not hidden.",
      "failed": "Failed to unhide message"
    }
  },
  "reportNotes": {
    "saveButton": "Save note",
    "saving": "Saving...",
    "success": "Note saved",
    "noChange": "No changes to save",
    "tooLong": "The note cannot exceed 1000 characters."
  },
  "userWallet": {
    "title": "Wallet",
    "viewLink": "View wallet",
    "balanceLabel": "Current balance",
    "withdrawableLabel": "Withdrawable",
    "nonWithdrawableLabel": "Non-withdrawable",
    "creditButton": "Credit manually",
    "back": "Back",
    "submitting": "Crediting...",
    "creditDialogTitle": "Credit wallet",
    "creditDialogSubtitle": "This action moves money and is logged in the admin audit trail.",
    "amountLabel": "Amount to credit",
    "amountHelper": "In euros (max 2 decimals), max {{max}} €",
    "amountTooLow": "Amount must be at least 0.01 €.",
    "amountTooHigh": "Amount cannot exceed {{max}} €.",
    "reasonLabel": "Reason",
    "reason": {
      "COMMERCIAL_GESTURE": "Commercial gesture",
      "SUPPORT_CORRECTION": "Support correction",
      "OTHER": "Other"
    },
    "noteLabel": "Internal note",
    "noteHelper": "Required, at least {{min}} characters.",
    "noteTooShort": "Note must be at least {{min}} characters.",
    "notePlaceholder": "Support ticket link, context...",
    "confirmSubtitle": "You are about to credit this user's wallet with:",
    "confirmIrreversible": "This credit is applied immediately and cannot be undone.",
    "creditSuccess": "Wallet credited",
    "creditError": "Credit failed",
    "errorLimitExceeded": "Amount exceeds the allowed credit limit.",
    "errorIdempotencyReuse": "This credit was already submitted with different values.",
    "transactionsTitle": "Recent transactions",
    "noTransactions": "No transactions.",
    "loadError": "Failed to load wallet.",
    "txnType": "Type",
    "txnAmount": "Amount",
    "txnBalanceAfter": "Balance after",
    "txnDescription": "Description",
    "txnDate": "Date",
    "txnOrderLink": "View order",
    "txnPayment": "Payment reference:",
    "txnPaymentMissing": "No payment record matches this reference. The order cannot be identified from this entry.",
    "txnNoOrder": "Payment recorded without a directly linked order. A live purchase may be grouped into an order later.",
    "transactionTypes": {
      "CREDIT_PLATFORM_FEES": "Platform fees credited",
      "DEBIT_PLATFORM_REFUND": "Platform fees refunded"
    }
  },
  "missingInvoices": {
    "title": "Missing Invoices",
    "intro": "Orders for which an expected legal invoice was never generated (silent failure). Retry generation, or fix the seller data if the failure is permanent.",
    "colOrder": "Order",
    "colConfirmedAt": "Confirmed at",
    "colMissingTypes": "Missing invoices",
    "colParticipants": "Shop / Buyer",
    "shop": "Shop",
    "buyer": "Buyer",
    "retry": "Retry",
    "retrying": "Retrying...",
    "retrySuccess": "{{count}} invoice(s) generated",
    "retryFailed": "{{count}} invoice(s) failed - check seller data",
    "retryNone": "No invoice generated",
    "empty": "No missing invoices",
    "emptyHint": "All expected legal invoices have been generated.",
    "loadError": "Failed to load missing invoices."
  },
  "finance": {
    "unavailable": "Unavailable",
    "title": "Overview",
    "refresh": "Refresh",
    "error": "Finance data could not be loaded. No amount can be confirmed.",
    "missingWallet": "Platform wallet not found. Balance is unavailable.",
    "balance": "Internal wallet balance",
    "gross": "Cumulative fee credits",
    "reversed": "Fee reversals (refunds)",
    "net": "Net fees recorded",
    "today": "Net fees today",
    "explanation": "Net fees = fee credits − reversals, regardless of order status. Includes delivery: this is neither profit nor the Stripe balance. The wallet balance also includes other movements.",
    "walletSection": "Internal balance",
    "walletHint": "Includes all wallet movements.",
    "feesSection": "Fee entries",
    "feesHint": "Amounts from wallet movements, before checking linked payments.",
    "reviewSection": "Needs review",
    "reviewHint": "Amounts already included above or still to be credited, to reconcile with payments.",
    "history": "View wallet transactions",
    "pending": "Credits being processed",
    "failed": "Failed credits",
    "missingCredits": "Outstanding fee credits",
    "orphanCredits": "Credits without a linked payment",
    "orphanExplanation": "These credits are included in the displayed amounts, but their linked payment is missing. Review before interpreting revenue.",
    "netHint": "Fee credits minus refunded fees.",
    "todayHint": "Since midnight, server time.",
    "scopeHint": "Delivery included · Neither profit nor Stripe balance.",
    "calculationDetails": "How fees are calculated",
    "entry": "Entry",
    "count": "Count",
    "amount": "Amount"
  },
  "integrity": {
    "showDetails": "View anomalies",
    "title": "Consistency check",
    "explanation": "Reconciles each payment and refund against ledger entries and the balance, to the cent. Recent shortfalls remain pending for 5 minutes. Automatic checks are scheduled every 5 minutes.",
    "error": "Check unavailable: financial consistency cannot be confirmed.",
    "status": {
      "OK": "No discrepancy detected",
      "PENDING": "Operations still processing",
      "CRITICAL": "Financial discrepancy detected — investigation required"
    },
    "checkedAt": "Checked at",
    "issues": "Issues",
    "pending": "Processing operations",
    "action": "Investigate the affected operations before making adjustments. Balances are never corrected automatically.",
    "sample": "Sample of up to 100 issues across categories. The count includes every issue; several may concern the same operation.",
    "kind": "Check",
    "reference": "Reference",
    "expected": "Expected",
    "actual": "Actual",
    "delta": "Difference",
    "kinds": {
      "CREDIT_MISMATCH": "Incorrect fee credit",
      "REFUND_MISMATCH": "Incorrect fee reversal",
      "ORPHAN_CREDIT": "Credit without captured payment",
      "ORPHAN_REVERSAL": "Debit without completed refund",
      "BALANCE_MISMATCH": "Balance differs from ledger",
      "MOVEMENT_MISMATCH": "Inconsistent movement",
      "WALLET_MISSING": "Missing wallet",
      "WRONG_WALLET": "Fees on another wallet",
      "FEE_RECORD_MISMATCH": "Inconsistent fee record",
      "FEE_RECORD_REVERSAL_MISMATCH": "Inconsistent reversal record",
      "ORPHAN_FEE_RECORD": "Fee record without ledger entry",
      "FEE_SOURCE_MISMATCH": "Conflicting fee sources",
      "CURRENCY_MISMATCH": "Inconsistent currency",
      "FEE_SOURCE_MISSING": "Missing fee source",
      "DUPLICATE_CREDIT": "Multiple credits for one payment",
      "PREPAID_FEE_REVIEW": "Live prepayment: historical fees require reconciliation"
    },
    "methodDetails": "How does this check work?"
  },
  "payments": {
    "title": "Payments",
    "requiresAction": "Awaiting action",
    "declinedRetry": "Declined, retry possible",
    "failure": {
      "generic_decline": "Generic decline from the bank",
      "insufficient_funds": "Insufficient funds",
      "card_declined": "Card declined",
      "expired_card": "Expired card",
      "incorrect_cvc": "Incorrect CVC",
      "processing_error": "Processing error",
      "lost_card": "Card reported lost",
      "stolen_card": "Card reported stolen",
      "payment_intent_authentication_failure": "3D Secure authentication failed",
      "unknown": "Unknown decline reason"
    }
  }
}
